// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"84052d39ff5866d8","537":"d9dbfa0cbbd4abb4"}[chunkId] + ".js";
};